import React from "react";
import "./aboutInfoContainer.css";
import TypewriterComponent from "../Components/Loader/Typewriter";

const AboutInfoContainer = ({ title, text, image }) => {
  return (
    <>
      <div className="about-info-container" style={{ display: 'flex', flexDirection: 'column', justifyContent: "center", alignItems: "center"}}>
        <p className="title-text-about mb-5 ">{title}</p>
          <p className="description-text" >
            <TypewriterComponent speed={10} >{text}</TypewriterComponent>
          </p>
      </div>
      {image ? image : null}
    </>
  );
};

export default AboutInfoContainer;
